import { useTranslation } from "react-i18next";
import { formatDate } from "../../config/i18n";
import { ReactComponent as IconInfoCircle } from 'bootstrap-icons/icons/info-circle.svg'

const {
  REACT_APP_CRONTU_M2M_ID
} = process.env

const CRONTU_M2M_MASK = "crontu"

const Info = ({ event, className }) => {
  const { t } = useTranslation();

  // Bug real (auditoría 2026-08-16): esto mutaba event.createdBy/updatedBy
  // IN PLACE — event es el mismo objeto que Agenda.js/Calendar.js tienen en
  // su state y que Event.js/Slot.js#changeStatus clona y persiste completo
  // al cambiar el status de un turno. Info.js renderiza en cada tick de
  // useTicker (1/seg); para cuando el profesional clickeaba un botón de
  // status, estos campos ya podían estar pisados con el string literal
  // "crontu", y se guardaba así en el backend, corrompiendo el audit trail.
  // Se usan variables locales de sólo lectura para mostrar el enmascarado.
  const createdBy =
    event.source === "crontu" && event.createdBy === REACT_APP_CRONTU_M2M_ID
      ? CRONTU_M2M_MASK
      : event.createdBy
  const updatedBy =
    event.source === "crontu" && event.updatedBy === REACT_APP_CRONTU_M2M_ID
      ? CRONTU_M2M_MASK
      : event.updatedBy

  const notifications = Object.values(event.notifications || {}).filter(n => n?.createdAt).sort(
    (a, b) => a.createdAt - b.createdAt
  );
  let html = `
    ${
      event.overbooking
        ? `<div class="text-uppercase fw-bold text-danger">${t(
            "overbooking"
          )}</div>`
        : ""
    }
    <dl>
      ${Array.isArray(event.reschedules) && event.reschedules.length > 0 ? (() => {
        const r = event.reschedules[event.reschedules.length - 1]
        return `
          <dt>${t('rescheduled_from', 'Reprogramado de')}</dt>
          <dd>${r.from.day.replace(/-/g, '/')} ${r.from.time} → ${r.to.day.replace(/-/g, '/')} ${r.to.time}</dd>
          <dd class="text-first-up opacity-75">${formatDate(r.at, 'EEEE d MMM HH:mm')}</dd>
        `
      })() : ''}
      ${!event.time && !!event.range ?(`
        <dt>${t("range_time", 'Rango Horario')}</dt>
        <dd>${event.range}</dd>
      `) : ''}
      <dt>${t("create", { context: "events" })}</dt>
      <dd>${createdBy}</dd>
      <dd class="text-first-up">${formatDate(
        event.createdAt,
        "EEEE d MMM HH:mm:ss"
      )}</dd>
      <dt>${t("update", { context: "events" })}</dt>
      <dd>${updatedBy}</dd>
      <dd class="text-first-up">${formatDate(
        event.updatedAt,
        "EEEE d MMM HH:mm:ss"
      )}</dd>
      ${
        Array.isArray(event.states)
          ? event.states
              .sort((a, b) => a.createdAt - b.createdAt)
              .map(
                (state) => `
        <dt>${t(`status_${state.status}`, { context: "events" })}</dt>
        ${state.by ? `<dd>${state.by === REACT_APP_CRONTU_M2M_ID ? CRONTU_M2M_MASK : state.by}</dd>` : ""}
        <dd class="text-first-up">${formatDate(
          state.createdAt,
          "EEEE d MMM HH:mm:ss"
        )}</dd>
      `
              )
              .join("")
          : ""
      }
      ${
        notifications.length > 0
          ? `<dt>${t("notifications", { context: "events" })}</dt>`
          : ""
      }
      ${notifications
        .map(
          (notification) => `
        <dd class="text-first-up">${t(
          notification.kind || "unkown"
        )} - ${formatDate(
            notification.createdAt,
            "EEEE d MMM HH:mm:ss" || 0
          )}</dd>
      `
        )
        .join("")}
    </dl>
  `;
  return (
    <IconInfoCircle
      width="14"
      height="14"
      data-tooltip-id="app-tooltip"
      data-tooltip-html={html}
    />
  );
};

export default Info;
